const detail = {
  line1: [
    {
      name: 'customerName',
      text: 'sale.sale_customer-name',
      component: 'MultipleSelectCustomerName'
    },
    {
      name: 'shipDate',
      text: 'ship.ship_ship-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'shipStorage',
      text: 'ship.ship_ship-storage',
      component: 'SelectStorageName',
      hasDefault: false,
      cols: 5
    },
    {
      name: 'shipStatus',
      text: 'sale.ship_ship-status',
      component: 'SelectStatusShip',
      cols: 4
    }
  ],
  line2: [
    {
      name: 'saleInfo',
      text: 'sale.sale_sale-info',
      component: 'SearchTwinTextboxInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    }
  ]
}

export default { detail }
